document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mobile-menu-panel a').forEach((link) => {
    link.addEventListener('click', () => {
      const menu = link.closest('details');
      if (menu) menu.removeAttribute('open');
    });
  });

  document.querySelectorAll('.quick-add-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button');
      if (!button || button.disabled) return;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Unable to add item');
        const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((result) => result.json());
        document.querySelectorAll('.bag-count').forEach((count) => {
          count.textContent = cart.item_count;
          count.classList.toggle('is-full', cart.item_count > 0);
        });
        button.textContent = 'Added to bag';
        window.setTimeout(() => { button.textContent = original; }, 1600);
      } catch (error) {
        button.textContent = 'View product';
        window.setTimeout(() => { window.location.href = form.closest('.product-card').querySelector('.product-image').href; }, 600);
      } finally {
        button.disabled = false;
      }
    });
  });
});
